import { combineReducers } from "redux"
import { buildingsDetails } from "./reducer.buildings"

const buildingReducers = combineReducers({
    buildingsDetails
})

export default buildingReducers